module.exports = {"TXTWCL_Login_to_bet":{"id":"TXTWCL_Login_to_bet","defaultMessage":"Login to Bet","track":"Login to Bet"}}